import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToque: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="toque, chefs-cap, cook"><path d="M19 18.25C19 20.3211 17.3211 22 15.25 22H8.75C6.67893 22 5 20.3211 5 18.25V18H19V18.25Z" fill="currentColor"/><path d="M12 2C14.222 2 16.1603 3.20843 17.1963 4.99902L17.1992 5.00391C19.8682 5.10857 22 7.30535 22 10C22 12.0503 20.7659 13.8124 19 14.584V16.5H5V14.584C3.2341 13.8124 2 12.0503 2 10C2 7.30541 4.13187 5.10867 6.80078 5.00391C7.83767 3.20843 9.7776 2 12 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconToque;
